document.addEventListener('turbolinks:load', () => {
  const video = document.querySelector('#home-video');
  if(video){
    video.addEventListener('playing', () => {
      video.classList.remove('trans')
    })
  }
})